module.exports = __webpack_public_path__ + "img/modulo_Parrafo_new.fd9bf16.svg";